<template>
  <div class="download-file-item">
    <a @click="downloadFile()" class="download-file-item__link" :class="classValid">{{ file.ime }} </a>
    <span class="download-file-item__text"> - {{ file.velikost }}</span>
    <span class="download-file-item__text" v-if="file.uploader"> - {{ file.uploader }}</span>
    <p>{{ file.comment }}</p>
  </div>
</template>

<script>
export default {
  name: "DownloadFilesItem",
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classValid() {
      let textPrimary = !this.$store.state.isHkom ? 'text-primary' : 'text-primary--green'
      return this.file.veljavnost ? textPrimary : 'text-disabled'
    }
  },
  methods: {
    downloadFile() {
      if (this.file.veljavnost) {
        this.$emit('download-file', this.file)
      }
    }
  }
}
</script>

<style lang="scss">
.download-file-item {
  font-weight: 600;
  padding: 9px 9px 9px 0;
  border-bottom: 1px solid #e7e7e7;

  &__link {
    text-decoration: underline;
    cursor: pointer;
  }

  &__text {
    color: #b7b7b7;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/download/DownloadFilesItem.vue